<!--
  [CW-PERSON-REFACTOR][WP-D3] Read-only rendering of the three-stage routing resolution
  (Vorgangstyp -> Routing-Profil -> nothing). Deliberately NOT a form: an inherited value is not IN
  the form field, the field is genuinely empty — a value written into it would turn the inheritance
  into a local copy on the next save.
-->
<div class="cw-routing-inheritance">

    @if (loading) {
        <div class="cw-routing-inheritance-hint">Routing-Konfiguration wird geladen …</div>
    }

    @if (errorMessage) {
        <p-message severity="error" styleClass="w-full">
            <span class="text-sm">{{ errorMessage }}</span>
        </p-message>
    }

    @if (!loading && !errorMessage && rows.length) {
        <div class="flex align-items-center justify-content-between mb-2">
            <span class="font-semibold">Anschrift und Kontakt — wirksame Zuordnung</span>
            @if (templateName) {
                <span class="text-sm">
                    Routing-Profil: <b>{{ templateName }}</b>
                </span>
            } @else {
                <span class="text-sm cw-routing-inheritance-muted">Kein Routing-Profil hinterlegt</span>
            }
        </div>

        <p-table [value]="rows" styleClass="p-datatable-sm" [rowTrackBy]="trackByRowKey">
            <ng-template pTemplate="header">
                <tr>
                    <th class="cw-routing-inheritance-col-axis">Angabe</th>
                    <th>Wirksamer Wert</th>
                    <th class="cw-routing-inheritance-col-source">Herkunft</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr [class.cw-routing-inheritance-row-inherited]="row.inherited">
                    <td class="cw-routing-inheritance-col-axis">{{ row.label }}</td>
                    <td>
                        @if (row.valueText) {
                            <span>{{ row.valueText }}</span>
                        } @else {
                            <span class="cw-routing-inheritance-muted">—</span>
                        }
                        @for (warning of row.warnings; track warning) {
                            <div class="cw-routing-inheritance-warning">
                                <i class="fa-solid fa-triangle-exclamation mr-1"></i>{{ warning }}
                            </div>
                        }
                    </td>
                    <td class="cw-routing-inheritance-col-source">
                        @if (row.inherited) {
                            <p-tag severity="info" [value]="row.sourceText"></p-tag>
                        } @else if (row.source === 'CASE_TYPE') {
                            <span class="text-sm">{{ row.sourceText }}</span>
                        } @else {
                            <span class="text-sm cw-routing-inheritance-muted">{{ row.sourceText }}</span>
                        }
                    </td>
                </tr>
            </ng-template>
        </p-table>

        @if (hasInheritedRows) {
            <div class="cw-routing-inheritance-hint mt-2">
                Kursiv hinterlegte Zeilen stammen aus dem Routing-Profil. Sobald am Vorgangstyp selbst
                ein Wert gesetzt wird, gilt dieser — das Profil wird dann für diese Angabe nicht mehr
                gelesen.
            </div>
        }

        @if (hasWarnings) {
            <div class="cw-routing-inheritance-hint mt-1">
                Ein Kontakt-Paar wirkt nur, wenn Kontakttyp <b>und</b> Feld auf <b>derselben</b> Stufe
                gesetzt sind. Mehrere Kontakttypen tragen denselben internen Typ „E-Mail“ — erst das
                Feld macht den Wert eindeutig.
            </div>
        }
    }

    @if (!loading && !errorMessage && !rows.length) {
        <div class="cw-routing-inheritance-hint">Keine Routing-Konfiguration ermittelbar.</div>
    }

</div>
